/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Router from "vue-router";
import Meta from "vue-meta";

Vue.use(Router);
Vue.use(Meta);
import auth from "./middleware/auth";
import guest from "./middleware/guest";
import middlewarePipeline from "./middleware/middlewarePipline";
import store from "./store/store";

// динамическая домашняя страница
// import { GenDashboard } from "./routes/dashboard";
//routes  src/routes

import laborRoute from "./routes/labor";
import ministry from "./routes/ministry";
import csak from "./routes/csak";
import geology from "./routes/geology";
import goskomles from "./routes/goskomles";
import minselxoz from "./routes/minselxoz";
import minvodxoz from "./routes/minvodxoz";
import goskomgeologiya from "./routes/goskomgeologiya";
import uzgidromet from "./routes/uzgidromet";
import monitoring from "./routes/monitoring";
import reports from "./routes/moduleReports";
import statistics from "./routes/statistics";

import dictionary from "./routes/dictionary";
import settings from "./routes/settings";
import notifications from "./routes/notifications";
import integrations from "./routes/integrations";
import help from "./routes/help";
import faq from "./routes/faq";
import {
  getUserData
} from "./utils/auth"; // localstorage

// const homePages = {
//   labor: "/labor/dashboard",
//   csak: "/csak/dashboard",`
//   // admin: "/dictionary/others",
//   admin: "/dictionary/others",
//   ministry: "/ministry/dashboard",
//   guest: "/ministry/dashboard",
//   goskomgeologiya: "/goskomgeologiya/dashboard",
//   goskomgeologiya: "/goskomgeologiya/dashboard",
//   goskomles: "/goskomles/dashboard_tree",
//   others: "/pages/error-405",
// }
const homePages = {
  laboratory: "/labor/dashboard",
  csak: "/ministries_dashboard/index",
  // admin: "/dictionary/others",
  admin: "/base/index",
  ministry: "/ministries_dashboard/index",
  guest: "/ministry/dashboard",
  goskomgeologiya: "/goskomgeologiya/dashboard",
  goskomles: "/goskomles/dashboard_tree",
  others: "/pages/error-405"
};

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    };
  },
  routes: [{
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: "",
      component: () => import("./layouts/main/Main.vue"),
      children: [{
          path: "/ministries_dashboard/index",
          name: "ministries_dashboard-index",

          component: () => import("./views/ministriesDasboard/index.vue"),
          meta: {
            middleware: [auth]
          }
        },

        // =============================================================================
        // Theme Routes
        // =============================================================================
        // {
        //   path: '/',
        //   name: 'home',
        //   component: () => import('./views/Home.vue'),
        //   meta: {
        //     middleware: [auth]
        //   }
        // },
        // {
        //   path: "/pages/knowledge-base",
        //   name: "pageKnowledgeBase",
        //   component: () =>
        //     import("./views/pages/knowledgebase/KnowledgeBase.vue"),
        //   meta: {
        //     middleware: [auth],
        //     breadcrumb: [
        //       {
        //         title: "Home",
        //         url: "/"
        //       },
        //       {
        //         title: "Pages"
        //       },
        //       {
        //         title: "KnowledgeBase",
        //         active: true
        //       }
        //     ],
        //     pageTitle: "KnowledgeBase",
        //     rule: "editor"
        //   }
        // },
        {
          path: "/pages/knowledge-base/:kbId",
          name: "pageKnowledgeBaseCategory",
          component: () =>
            import("./views/pages/knowledgebase/KnowledgeBaseCategory.vue"),
          meta: {
            middleware: [auth],
            breadcrumb: [{
                title: "Home",
                url: "/"
              },
              {
                title: "Pages"
              },
              {
                title: "KnowledgeBase",
                url: "/pages/knowledge-base"
              },
              {
                title: "Category",
                active: true
              }
            ],
            rule: "editor"
          }
        },
        {
          path: "/pages/knowledge-base/category/:itemId",
          name: "pageKnowledgeBaseCategoryItem",
          component: () =>
            import(
              "./views/pages/knowledgebase/KnowledgeBaseCategoryQuestion.vue"
            ),
          meta: {
            middleware: [auth],
            breadcrumb: [{
                title: "Home",
                url: "/"
              },
              {
                title: "Pages"
              },
              {
                title: "KnowledgeBase",
                url: "/pages/knowledge-base"
              },
              {
                title: "Category",
                url: "/pages/knowledge-base/category"
              },
              {
                title: "Question",
                active: true
              }
            ],
            rule: "editor"
          }
        },
        {
          path: "/pages/energy-audit/map",
          name: "pageEnergyAuditMap",
          component: () => import("./views/pages/energyaudit/map.vue"),
          meta: {
            middleware: [auth],
            breadcrumb: [{
                title: "Home",
                url: "/"
              },
              {
                title: "Pages"
              },
              {
                title: "EnergyAudit",
                active: true
              }
            ],
            pageTitle: "Map",
            rule: "editor"
          }
        },

        //ECOLOGY Front
        // ...dashboard,
        {
          path: "/",
          redirect: to => {
            // console.log("store", store.state.AppActiveUser.roles[0]);
            if (!getUserData()) return `pages/login`;

            // var currentRole = JSON.parse(getUserData()).roles[0].name || "";
            // // var currentRole = store.state.AppActiveUser.roles[0].name || "";
            // currentRole = currentRole.toLowerCase().replaceAll('"', "");
            // console.log(currentRole, 'currentRole')
            return homePages['admin'] || homePages["others"];
            // if (currentRole === "labor") {
            //   return "/labor/dashboard";
            // } else if (currentRole === "csak") {
            //   return "/csak/dashboard";
            // } else if (currentRole === "admin") {
            //   return "/dictionary/others";
            //   // return "/settings/dashboard";
            // } else if (currentRole === "ministry") {
            //   return "/ministry/dashboard";
            // } else if (currentRole === "guest") {
            //   return "/ministry/dashboard/";
            // } else if (currentRole === "goskomgeologiya") {
            //   return "/goskomgeologiya/dashboard";
            // } else if (currentRole === "goskomles") {
            //   return "/goskomles/dashboard_tree";
            // } else {
            //   return "/pages/error-405";
            //   // return "/settings/dashboard";
            // }
            // the function receives the target route as the argument
            // return redirect path/location here.
          }
        },
        ...ministry,
        ...csak,
        ...geology,
        ...goskomles,
        ...minselxoz,
        ...minvodxoz,
        ...goskomgeologiya,
        ...uzgidromet,
        ...reports,
        ...statistics,
        ...dictionary,
        ...laborRoute,
        ...settings,
        ...notifications,
        ...integrations,
        ...help,
        ...monitoring,
        ...faq
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPage.vue"),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: "/pages/login",
          name: "login",
          component: () => import("@/views/pages/Login.vue"),
          meta: {
            middleware: [guest]
          }
        },
        {
          path: "/pages/error-404",
          name: "page-error-404",
          component: () => import("@/views/pages/Error404.vue")
        },
        {
          path: "/pages/error-405",
          name: "page-error-405",
          component: () => import("@/views/pages/NotIntegreted.vue")
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/pages/error-404"
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (!to.meta.middleware) {
    next();
  }
  const middleware = to.meta.middleware;

  const context = {
    to,
    from,
    next,
    store
  };
  if (middleware) {
    return middleware[0]({
      ...context,
      next: middlewarePipeline(context, middleware, 1)
    });
  }
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
